var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarEngine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M490.667,170.667h-33.685c-9.451,0-17.771,6.229-20.459,15.275L415.787,256h-2.304l-9.216-27.989 c-2.901-8.768-11.051-14.677-20.267-14.677h-42.667V192c0-11.776-9.536-21.333-21.333-21.333h-42.667v-21.333h21.333 c11.797,0,21.333-9.557,21.333-21.333V64c0-11.776-9.536-21.333-21.333-21.333H128c-11.797,0-21.333,9.557-21.333,21.333v64 c0,11.776,9.536,21.333,21.333,21.333h21.333v21.333h-64C73.536,170.667,64,180.224,64,192v85.333H42.667V256 c0-11.776-9.536-21.333-21.333-21.333C9.536,234.667,0,244.224,0,256v85.333c0,11.776,9.536,21.333,21.333,21.333 c11.797,0,21.333-9.557,21.333-21.333V320H64v42.667c0,3.157,0.704,6.272,2.069,9.131l30.315,64 c3.52,7.445,11.008,12.203,19.264,12.203h257.131c7.531,0,14.507-3.989,18.347-10.453l19.093-32.213h6.997l19.904,50.496 c3.243,8.149,11.115,13.504,19.861,13.504h33.685c11.797,0,21.333-9.557,21.333-21.333V192 C512,180.224,502.464,170.667,490.667,170.667z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarEngine);
export default __webpack_public_path__ + "static/media/car_engine.2f6e9a6c0027fa2f01609a87a42a3e3c.svg";
export { ForwardRef as ReactComponent };